import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

/** Gemeinsamer Rahmen für Login und Registrierung. */
export default function AuthShell({
  title,
  subtitle,
  children,
}: {
  title: string
  subtitle?: string
  children: ReactNode
}) {
  const { t } = useTranslation()

  return (
    <div className="flex min-h-full items-center justify-center px-5 py-12">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <p className="text-roast-500 dark:text-crema-300 text-xs font-medium tracking-[0.2em] uppercase">
            {t('app.name')}
          </p>
          <h1 className="mt-2 text-2xl font-semibold tracking-tight">{title}</h1>
          {subtitle && (
            <p className="text-roast-600 dark:text-crema-200/80 mt-1 text-sm">{subtitle}</p>
          )}
        </div>

        <div className="border-crema-200 dark:border-roast-700 dark:bg-roast-800/50 rounded-xl border bg-white/70 p-6 shadow-sm">
          {children}
        </div>
      </div>
    </div>
  )
}
